/**
 * Online Ordering Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ChannelEnum {

    Pos = 'pos',

    Online = 'online',

    Kiosk = 'kiosk',

    Phone = 'phone',

    Aggregator = 'aggregator',

    CallCenter = 'call_center'
}

